export default "__VITE_ASSET__COg2_djp__"